import { createFileRoute, redirect } from '@tanstack/react-router'
import { resolveRootLocale } from '~/utils/resolve-locale'

// B-new-1008 — bare `/` must not unconditionally land on a hardcoded
// Spanish sign-in form. Resolve a locale (saved -> browser -> en, see
// resolveRootLocale) and hand off to the LOCALE-scoped index route
// (/$locale/index.tsx, route id '/$locale'), which already does the session check: signed in
// -> /$locale/jobs, signed out -> /$locale/sign-in. Reusing that route
// instead of duplicating the auth check here.
export const Route = createFileRoute('/')({
  loader: () => {
    const locale = resolveRootLocale()
    throw redirect({
      to: '/$locale',
      params: { locale },
    })
  },
  component: () => null, // Never renders
})
